import * as t from "io-ts";

export const DesignProviderMetaV = t.type({
  thumbnailUrl: t.union([t.string, t.undefined])
});

export const DesignProviderV = t.type({
  name: t.string,
  url: t.string,
  type: t.union([
    t.literal("complete_site"),
    t.literal("sections"),
    t.literal("ui_kit"),
    t.undefined
  ]),
  isLocal: t.union([t.boolean, t.undefined]),
  meta: t.union([t.undefined, DesignProviderMetaV])
});

export type DesignProvider = t.TypeOf<typeof DesignProviderV>;

// partial for backward compatibility
export const DesignLibraryDataV = t.type({
  designProviders: t.array(DesignProviderV),
  globalSettingsLastImportedFromUrl: t.union([t.string, t.null]),
  designPresetsLastImportedFromUrl: t.union([t.string, t.null]),
  variablesLastImportedFromUrl: t.union([t.string, t.null]),
  oxySelectorsLastImportedFromUrl: t.union([t.string, t.null]),
  fullSiteLastImportedFromUrl: t.union([t.string, t.null]),
  isGlobalSettingsEnabled: t.boolean,
  isDesignPresetsEnabled: t.boolean,
  isVariablesEnabled: t.boolean,
  isOxySelectorsEnabled: t.boolean,
  isPopupsEnabled: t.boolean
});

export type DesignLibraryData = t.TypeOf<typeof DesignLibraryDataV>;

// Design Sets
export const DesignSetPostV = t.intersection([
  t.type({
    id: t.number,
    name: t.string,
    url: t.string,
    tags: t.array(t.string)
  }),
  t.partial({
    type: t.string
  })
]);

export const DesignSetDataV = t.type({
  enabled: t.boolean,
  // needed for backward compatibility. There may be design sets on an older version on Breakdance
  // without "reliesOnGlobalSettings"
  reliesOnGlobalSettings: t.union([t.boolean, t.undefined]),
  reliesOnDesignPresets: t.union([t.boolean, t.undefined]),
  name: t.string,
  requiresPassword: t.union([t.boolean, t.undefined]),
  passwordValid: t.union([t.boolean, t.undefined]),
  posts: t.array(DesignSetPostV)
});

export type DesignSetPost = t.TypeOf<typeof DesignSetPostV>;
export type DesignSetData = t.TypeOf<typeof DesignSetDataV>;

// Screenshot

export const ScreenshotV = t.type({ url: t.string, id: t.number });

export type Screenshot = t.TypeOf<typeof ScreenshotV>;
